import store from '../store'

export const authorizeToken = (to, from, next) => {
  window.stop()
  const routeGuard = (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!store.state.Auth.user) {
        next({ path: '/Login' })
      } else {
        next()
      }
    } else if ((to.path === '/Login' || to.path === '/') && store.state.Auth.user) {
      next({ path: '/Home' })
    } else {
      next()
    }
  }
  if (!from.name || to.name === 'Login') {
    store.dispatch('Auth/initUser', null)
      .then(output => {
        routeGuard(to, from, next)
      })
  } else {
    routeGuard(to, from, next)
  }
}
